const mutations = {
  SET_PROGRESS(state, {type, progress}) {
    state.progress[type] = progress
  },
  RESET_PROGRESS(state, type) {
    state.progress[type] = 100
  },
}

export { mutations }
